import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'lib-g99-shared-popover',
  templateUrl: './shared-popover.component.html',
  styleUrl: './shared-popover.component.scss',
  standalone: false,
})
export class SharedPopoverComponent {
  @Input() public content!: TemplateRef<unknown>;
  @Input() public dismissable = false; // Allow dismissing by clicking outside

  @ViewChild('popoverRef', { static: false, read: OverlayPanel })
  protected popoverRef!: OverlayPanel;

  public toggle(event: Event) {
    if (this.popoverRef.overlayVisible) {
      this.popoverRef.hide();
    } else {
      this.popoverRef.show(event);
    }
  }

  public show(event: Event) {
    this.popoverRef.show(event);
  }

  public hide() {
    this.popoverRef.hide();
  }
}
